import React, { useState } from 'react';

import {
  Block,
  CoreLink,
  View,
} from '@uncinc/react-drupal-core';
import config from 'react-global-configuration';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';

import NavigationMainMenuSubComponent from './NavigationMainMenuSubComponent';
import NavigationMainMenuSubComponentKVNL from './NavigationMainMenuSubComponentKVNL';

import { DOMAIN_KVNL, DOMAIN_VNL } from '../../../config/constants';

import './style.scss';

const MenuItem = ({ id, attrs, title, href, item, children }) => {
  const [expanded, setExpanded] = useState(false);

  const currentDomain = config.get('CURRENT_DOMAIN');
  const itemIconClass = classnames('icon icon-chevron-right');

  return (
    <li
      key={`menu--main--menu-item-${title}:${href}`}
      className="menu--main--menu-item"
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
    >
      <div className="NavigationMainMenuDesktop__title">
        {/* Link (currently not used) */}
        {href && attrs && (
          <CoreLink
            to={href}
            target={attrs.get('target')}
          >
            {title}
          </CoreLink>
        )}
        {/* Button (currently the only option used) */}
        {!href && (
          <button
            className="NavigationMainMenuDesktop__button"
            type="button"
            aria-expanded={expanded}
            onClick={() => setExpanded(!expanded)}
          >
            {title}
            {currentDomain === DOMAIN_VNL && (
              <div className={itemIconClass} />
            )}
            {currentDomain === DOMAIN_KVNL && (
              expanded ? <div className="icon icon-cross" /> : <div className="icon icon-hamburger" />
            )}
          </button>
        )}
      </div>
      {children && (
        <div className="NavigationMainMenuDesktop--subMenu">
          <Container className="NavigationMainMenuDesktop--subMenu__container">
            {children}
          </Container>
        </div>
      )}
      {!children && currentDomain === DOMAIN_KVNL && (
        <NavigationMainMenuSubComponentKVNL item={item} />
      )}
      {!children && currentDomain !== DOMAIN_KVNL && (
        <NavigationMainMenuSubComponent item={item} />
      )}
    </li>
  );
};

const NavigationMainMenuDesktop = ({ items }) => {
  const { t } = useTranslation();
  const themeMenuFeaturedBlock = config.get('THEME_MENU_FEATURED_BLOCK');

  return (
    <ul className="NavigationMainMenuDesktop__items">
      <MenuItem
        id="menu-item-themes"
        title={t('tags.plural.theme')}
      >
        <div className="NavigationMainMenuDesktop__items__theme-featured">
          <View id="vocabulary_terms" display="themes" showTitle={false} menuTeaser isDesktop />
          <Block id={themeMenuFeaturedBlock} />
        </div>
      </MenuItem>
      {items.map((item, index) => {
        const attrs = item.getIn(['link', 'options', 'attributes'], new Map());
        const href = item.getIn(['link', 'url'], '');
        const title = item.getIn(['link', 'title'], 'Untitled');
        return (
          <MenuItem
            id={`menu-item-${index}`}
            attrs={attrs}
            href={href}
            title={title}
            item={item}
          />
        );
      })}
    </ul>
  );
};

export default NavigationMainMenuDesktop;
